import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ShowmenuService {
  private showMenu = new BehaviorSubject(false);
  currentshowMenu = this.showMenu.asObservable();
  //showmenu=false;

  constructor() {}

  changeShowmenu(showmenu: boolean) {
    this.showMenu.next(showmenu);
    //this.showmenu=showmenu;
  }
}

//https://fireship.io/lessons/sharing-data-between-angular-components-four-methods/
